export default __webpack_public_path__ + "6640acee7617df459835f8a475db70fc.png";